module.exports = __webpack_public_path__ + "img/podium_5051.45773dcc.jpg";